export default "/assets/899b236be07d6760.png"